module.exports = __webpack_public_path__ + "static/media/ic_chevron_right_black.8a6460c4.svg";